/* eslint-disable import/prefer-default-export */
export const dateUtilityMixin = {
  methods: {
    // convert date to UTC
    getDateInUTCFormat(cd) {
      let currentDate = cd;
      if (!currentDate) currentDate = new Date();
      if (typeof currentDate === 'string') currentDate = new Date(currentDate);
      const convertedDate = new Date(currentDate.getUTCFullYear(), currentDate.getUTCMonth(), currentDate.getUTCDate(), currentDate.getUTCHours(), currentDate.getUTCMinutes(), currentDate.getUTCMinutes(), currentDate.getUTCMilliseconds());
      return convertedDate;
    }
  }
}
